import { render, staticRenderFns } from "./ReportCardLineChart.vue?vue&type=template&id=56f198cb"
import script from "./ReportCardLineChart.vue?vue&type=script&lang=ts"
export * from "./ReportCardLineChart.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports